import { connect } from 'react-redux';
import SEARCH_CONTEXT from '../../../helpers/InventorySearchContext';
import { getIsFetching } from '../../../redux/Inventory/selectors/item';
import { getPaginationQueryOptions } from '../../../redux/Inventory/selectors/item/pagination';
import { getSearchQueryForContext } from '../../../redux/Inventory/selectors/components/search';
import {
  getItemTagsSearchOptions,
  getIsFetchingItemTagsOptions
} from '../../../redux/Inventory/selectors/components/search-options';
import {
  onChangeQuery,
  onClearQuery
} from '../../../redux/Inventory/actions/components/search';
import { clearInventoryItems } from '../../../redux/Inventory/actions/item';
import {
  fetchInventoryItems,
  fetchInventoryItemTagsOptions
} from '../../../redux/Inventory/sagas/routines';
import InventoryItemSearch from '../../../components/inventory/ItemSearch';
import { ItemType } from '../../../constants/inventory/InventoryTypes';

function mapStateToProps(state, props) {
  const searchQuery = getSearchQueryForContext(state, SEARCH_CONTEXT.ITEM);
  const paginationQuery = getPaginationQueryOptions(state);
  const queryOptions = { ...paginationQuery, ...searchQuery, page: 1 };
  return {
    ...props,
    searchQuery,
    queryOptions,
    type: ItemType,
    tagsOptions: getItemTagsSearchOptions(state),
    isFetching: getIsFetching(state),
    isFetchingTagsOptions: getIsFetchingItemTagsOptions(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      dispatch(fetchInventoryItemTagsOptions());
    },
    onSubmit: queryOptions => {
      dispatch(clearInventoryItems());
      dispatch(fetchInventoryItems(queryOptions));
    },
    onChange: query => {
      dispatch(onChangeQuery({ context: SEARCH_CONTEXT.ITEM, query }));
    },
    onClear: () => {
      dispatch(onClearQuery({ context: SEARCH_CONTEXT.ITEM }));
      dispatch(clearInventoryItems());
      dispatch(fetchInventoryItems({}));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryItemSearch);
